import { BrowserRouter } from 'react-router-dom';
import './App.css';
import AppRouter from './routes/AppRouter';
import { ToastContainer } from "react-toastify";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch,useSelector  } from "react-redux";
import { checkTokenExpiration ,logout } from "../src/slices/authSlice";
import { handleAuthError } from "./utils/functions";
import axios from "axios";

import { jwtDecode } from 'jwt-decode';

const SESSION_POLL_INTERVAL = 20 * 1000; 


function App() {
  
  return (
    <>
      <ToastContainer />
      <BrowserRouter>
        <TrackLastVisitedPath />
        <AppRouter />
      </BrowserRouter>
    </>
  );
}

export default App;

// This component uses `useLocation` safely inside BrowserRouter

const TrackLastVisitedPath = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);
  const INACTIVITY_TIMEOUT = 60 * 60 * 1000;

  // Save last visited path
  useEffect(() => {
    sessionStorage.setItem("lastVisitedPath", location.pathname);
  }, [location.pathname]);

  // Check token validity on mount
  useEffect(() => {
    dispatch(checkTokenExpiration());
  }, [dispatch]);

  useEffect(() => {
    if (!token) return;

    let cancelled = false;

    const checkSession = async () => {
      if (cancelled || document.hidden) return;
      try {
        await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/session-status`,
          { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
        );
      } catch (error) {
        if (!cancelled) handleAuthError(error, dispatch, navigate);
      }
    };

    const intervalId = setInterval(checkSession, SESSION_POLL_INTERVAL);
    const onFocus = () => checkSession();
    window.addEventListener("focus", onFocus);
    document.addEventListener("visibilitychange", onFocus);
    checkSession();

    return () => {
      cancelled = true;
      clearInterval(intervalId);
      window.removeEventListener("focus", onFocus);
      document.removeEventListener("visibilitychange", onFocus);
    };
  }, [token, dispatch, navigate]);

  // Auto Logout due to inactivity
  useEffect(() => {
  if (!token) return;

  let inactivityTimer;

  const resetInactivityTimer = () => {
    clearTimeout(inactivityTimer);

    inactivityTimer = setTimeout(() => {
      dispatch(logout());
    }, INACTIVITY_TIMEOUT);
  };

  resetInactivityTimer();

  const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];
  events.forEach(event => {
    window.addEventListener(event, resetInactivityTimer);
  });

  return () => {
    clearTimeout(inactivityTimer);
    events.forEach(event => {
      window.removeEventListener(event, resetInactivityTimer);
    });
  };
}, [dispatch, token]);


  return null;
};